export const PLUGIN_KEY = 'aks-insert-link';

export enum AksInsertLinkButton {
  InsertLink = 'aks-insert-link',
  EditLink = 'aks-edit-link',
  RemoveLink = 'aks-remove-link',
  OpenLink = 'aks-open-link',
}
